export default __webpack_public_path__ + "static/media/iconMapPinWhite.f85000e1.svg";